import { render, staticRenderFns } from "./TendExportSettings.vue?vue&type=template&id=3ba9640b&scoped=true"
import script from "./TendExportSettings.vue?vue&type=script&lang=ts"
export * from "./TendExportSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9640b",
  null
  
)

export default component.exports